import AppService from '../shared/App.api';

export default {
  getStorePhotos,
};

const storePhotosUrl = '/admin/store-photos';

async function getStorePhotos() {
  try {
    const response = await AppService.get(storePhotosUrl);
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch store photos');
  }
}
